import { createSlice } from "@reduxjs/toolkit";
import { getCampaigns } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { ICampaign } from "api/types/_campaign";



export interface IState {
  campaigns: ResponseData<ICampaign[]> & PaginationResponse | null,
  isCampaignLoading: boolean,
  isCampaignSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  campaigns: null,
  isCampaignLoading: false,
  isCampaignSuccess: false,

  error: {},
};

const CampaignSlice = createSlice({
  name: "Campaign",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Campaigns
    builder.addCase(getCampaigns.pending, (state: IState, action: any) => {
      state.isCampaignLoading = true
    });
    builder.addCase(getCampaigns.fulfilled, (state: IState, action: any) => {
      state.campaigns = {
        list: action.payload?.data || [],
        pagination: {
          total: Number(action.payload?.data?.length || 0),
          page: 1,
          limit: 100,
        }
      } as any;
      state.isCampaignSuccess = true;
      state.isCampaignLoading = false;
    });
    builder.addCase(getCampaigns.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCampaignSuccess = false;
      state.isCampaignLoading = false;
    });
  },
});

export default CampaignSlice.reducer;